import { cn } from "@/lib/utils";

const TONE = {
  slate: "bg-slate-100 text-slate-700 border-slate-200",
  navy: "bg-slate-900 text-white border-slate-900",
  green: "bg-emerald-50 text-emerald-700 border-emerald-200",
  amber: "bg-amber-50 text-amber-800 border-amber-200",
  red: "bg-rose-50 text-rose-700 border-rose-200",
  blue: "bg-sky-50 text-sky-700 border-sky-200",
  violet: "bg-violet-50 text-violet-700 border-violet-200",
};

const STATE_TONE = {
  in_use: "green",
  in_warehouse: "slate",
  available: "slate",
  ready_to_deploy: "blue",
  reserved: "amber",
  packed: "blue",
  in_transit: "blue",
  in_transit_recovery: "blue",
  shipped: "blue",
  under_repair: "amber",
  awaiting_inspection: "amber",
  recovery_scheduled: "amber",
  assigned: "green",
  pending_approval: "amber",
  approved: "green",
  in_progress: "blue",
  rejected: "red",
  cancelled: "red",
  closed: "slate",
  delivered: "green",
  scheduled: "amber",
  picked_up: "blue",
  received: "blue",
  inspected: "green",
  failed: "red",
  open: "amber",
  clarification: "amber",
  operations_queue: "blue",
  disposed: "slate",
  destroyed: "slate",
  recycled: "slate",
  retired: "slate",
  resold: "slate",
  donated: "slate",
  returned_to_customer: "slate",
  on_track: "green",
  at_risk: "amber",
  breached: "red",
  completed: "green",
  pending: "amber",
  certified: "green",
  not_required: "slate",
  A: "green",
  B: "blue",
  C: "amber",
  D: "red",
  Scrap: "red",
};

export default function StatusBadge({ value, tone, className }) {
  if (!value && value !== 0) return null;
  const t = tone || STATE_TONE[value] || "slate";
  const label = String(value).replace(/_/g, " ");
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium tracking-tight capitalize",
        TONE[t],
        className
      )}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" />
      {label}
    </span>
  );
}
